import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';
import { MailingChannelEnum } from '@zaoblako/shared/modules/notification/enums/mailing.channel.enum';

/** Localized human-readable string representations of {@link MailingChannelEnum} enumeration values */
export const MailingChannelEnumI18n: EnumI18nInterface<MailingChannelEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [MailingChannelEnum.TELEGRAM]: 'Telegram',
    [MailingChannelEnum.WHATSAPP]: 'WhatsApp',
    [MailingChannelEnum.SMS]: 'SMS',
    [MailingChannelEnum.EMAIL]: 'Почта',
  },
  [I18nLocalesEnum.EN_US]: {
    [MailingChannelEnum.TELEGRAM]: 'Telegram',
    [MailingChannelEnum.WHATSAPP]: 'WhatsApp',
    [MailingChannelEnum.SMS]: 'SMS',
    [MailingChannelEnum.EMAIL]: 'Email',
  },
};
